import { Dispatch, SetStateAction } from 'react';

import { ENTER_KEYCODE } from 'coreOld/constants';
import { goTo } from 'coreOld/utils';
import { oldPartsPath } from 'partsOld/routes/routePaths';

import SearchFieldView from './SearchFieldView';

interface IProps {
  setIsSearchFocus: Dispatch<SetStateAction<boolean>>;
}

const SearchField = ({ setIsSearchFocus }: IProps) => {
  const goToParts = (search?: string) => {
    goTo(oldPartsPath(search));
  };

  const handleOnKeyDown = (event, search: string) => {
    if (event?.keyCode === ENTER_KEYCODE) {
      event.preventDefault();

      goToParts(search);
    }
  };

  return (
    <SearchFieldView
      goToParts={goToParts}
      onKeyDown={handleOnKeyDown}
      setIsSearchFocus={setIsSearchFocus}
    />
  );
};

export default SearchField;
